export default __webpack_public_path__ + "static/media/ExecutiveSummaryWithoutEditMode.f444e00a.png";